module.exports = __webpack_public_path__ + "static/media/u40_premium_contract1.a5253628.webp";